/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_EditInputs */

const cs_deal_provision_edit = /** @type {(inputs: Deal_Provision_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit provizi`)
};

const en_deal_provision_edit = /** @type {(inputs: Deal_Provision_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit commission`)
};

/**
* | output |
* | --- |
* | "Edit commission" |
*
* @param {Deal_Provision_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_edit = /** @type {((inputs?: Deal_Provision_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_edit(inputs)
	return cs_deal_provision_edit(inputs)
});